const getWeather = 'https://demo.shequyun.cn/area-to-weather'
/**濮阳运行监控 */
/**概览 */
let host = process.env.VUE_APP_host;
const realnameCount = host + "jczl/api/py-app-count/real-name/count"
const newUser = host + "jczl/api/py-app-count/month/access4new-user"
const monthAccess = host + 'jczl/api/py-app-count/month/access'
const overview = host + 'jczl/api/py-app-count/overview'
const monthHandle = host +'jczl/api/py-app-count/month/handle'
const handleTop10 = host + 'jczl/api/py-app-count/handle/top10'
const eventLatest10 = host + 'jczl/api/py-app-count/event/latest10'
const eatateLatest10 = host + 'jczl/api/py-app-count/estate/latest10'

/**不动产 */
const getHandleCount = host + 'jczl/api/py-app-count/estate/handle-count'
const getDailyHandleCount = host + 'jczl/api/py-app-count/estate/daily/handle-count'
const estateOverView = host + 'jczl/api/py-app-count/estate/overview'
const estateTop5 = host + 'jczl/api/py-app-count/estate/handle-count/top5'
const estateNewest10 =  host + 'jczl/api/py-app-count/estate/newest10'


/**首席服务员 */

const collectNumberByType = host + 'jczl/api/py-app-count/waiter/getCollectQuestionCountByType'  //收集问题各类型数量
const resolveNumberByType = host + 'jczl/api/py-app-count/waiter/getResolveQuestionCountByType'  //解决问题各类型数量
const meetingNumberByType = host + 'jczl/api/py-app-count/waiter/getMeetingQuestionCountByType'  //提交工作专班问题各类型数量
const totalCount = host + 'jczl/api/py-app-count/waiter/getTotleCount' //总数
const questionList = host + 'jczl/api/waiter/question/list' //收集问题和解决问题列
const companyType = host + 'jczl/api/py-app-count/waiter/getCompanyCountByType'  //企业类型统计
const companyRank = host + 'jczl/api/py-app-count/waiter/getCompanyQuestionCount'  //企业问题排名
const cheifNumber = host + 'jczl/api/py-app-count/waiter/getWaiterCountOfCompantType'  //首席服务员数
const cheifRank = host + 'jczl/api/py-app-count/waiter/getWaiterQuestionCount' //首席服务员排名
const ageCount = host + 'jczl/api/py-app-count/waiter/getWaiterCountByAge' //年龄统计
const getPeopleTypeNumber = host + 'jczl/api/py-app-count/waiter/getWaiterCountByRank' //人员类型统计

/**事件统计 */
const monitor_eventList = host + 'jczl/api/py-app-count/events/getEventsList'
const monitor_eventcount_hour = host +'jczl/api/py-app-count/events/getEventsCountOfEveryHour' //事件上报时间点统计
const monitor_event_hotmap = host + 'jczl/api/py-app-count/events/getEventsListHotMap'
const monitor_eventTotal = host + 'jczl/api/py-app-count/events/getTotleCount'
const monitor_eventFinishMonth = host + 'jczl/api/py-app-count/events/getEventsTotalAndFinishedCountOfEveryMonth'
const monitor_eventEvaluateCount = host + 'jczl/api/py-app-count/events/getEventsEvaluationCount'
const monitor_eventUserAge = host + 'jczl/api/py-app-count/events/getEventsPeopleCountOfAge'
const monitor_eventSolveTime = host + 'jczl/api/py-app-count/events/getEventsFinishedTimeCount'

/**丛台先锋运行监控 */
const xf_overview = host + 'jczl/api/ctxf-app-count/overview'
const xf_partyMemeber = host + 'jczl/api/ctxf-app-count/street/party-member-count'
const xf_workDynamic = (levelType) => host + `jczl/api/ctxf-app-count/${levelType}/work-dynamic/newest`
const xf_grid = host + 'jczl/api/ctxf-app-count/street/grid-count'
const xf_wy = host + 'jczl/api/ctxf-app-count/street/property-committee-count'
const xf_volunteer = host + 'jczl//api/ctxf-app-count/volunteer-org-count'
const xf_study = host + 'jczl/api/ctxf-app-count/study/newest'
const xf_partyDetail = (partyId) => host +  `jczl/api/ctxf-app-count/party/${partyId}/detail`

export default {
    realnameCount,
    newUser,
    monthAccess,
    overview,
    monthHandle,
    handleTop10,
    eventLatest10,
    eatateLatest10,
    getWeather,
    getHandleCount,
    getDailyHandleCount,
    estateOverView,
    estateTop5,
    estateNewest10,
    /**首席服务员 */
    collectNumberByType,
    resolveNumberByType,
    meetingNumberByType,
    totalCount,
    questionList,
    companyType,
    companyRank,
    cheifNumber,
    cheifRank,
    ageCount,
    getPeopleTypeNumber,
    /**事件统计 */
    monitor_eventList,
    monitor_eventcount_hour,
    monitor_event_hotmap,
    monitor_eventTotal,
    monitor_eventFinishMonth,
    monitor_eventEvaluateCount,
    monitor_eventUserAge,
    monitor_eventSolveTime,
    /**丛台 */
    xf_overview,
    xf_partyMemeber,
    xf_workDynamic,
    xf_grid,
    xf_wy,
    xf_volunteer,
    xf_study,
    xf_partyDetail
}